import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const categoryIcons: Record<string, string> = {
    hot: 'ri-fire-line',
    romance: 'ri-heart-line',
    fantasy: 'ri-magic-line',
    action: 'ri-sword-line',
    mystery: 'ri-search-eye-line',
    bl: 'ri-double-quotes-r',
    comedy: 'ri-emotion-laugh-line',
    latest: 'ri-rocket-line',
  };

  const categoryColors: Record<string, string> = {
    hot: 'bg-primary-100 text-primary-600',
    romance: 'bg-accent-100 text-accent-700',
    fantasy: 'bg-secondary-100 text-secondary-700',
    action: 'bg-primary-100/70 text-primary-600',
    mystery: 'bg-accent-100/70 text-accent-700',
    bl: 'bg-secondary-100/70 text-secondary-700',
    comedy: 'bg-primary-100/50 text-primary-600',
    latest: 'bg-accent-100/50 text-accent-700',
  };

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          分类浏览
        </h2>
        <p className="text-sm text-foreground-500 mt-2">按分类找到你喜欢的韩漫类型</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-center gap-3 bg-background-50 hover:bg-background-100 border border-background-200/70 rounded-lg p-4 cursor-pointer transition-all duration-200"
          >
            <div className={`w-10 h-10 flex items-center justify-center rounded-full ${categoryColors[cat.slug] || 'bg-secondary-100 text-secondary-600'}`}>
              <i className={`${categoryIcons[cat.slug] || 'ri-bookmark-line'} text-lg`}></i>
            </div>
            <div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </span>
              <p className="text-xs text-foreground-500 mt-0.5">
                {cat.slug === 'hot' ? '大家都在看' :
                 cat.slug === 'latest' ? '新鲜上架' : '精彩韩漫'}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}